module.exports = __webpack_public_path__ + "static/what-is-lekker-09be66ea85194694fceaa5c61d446cd1.png";